module.exports = "/images/daily-tribune.png?93914718c389f5373d46a49d2c43e048";